import React from 'react';
import PropTypes from 'prop-types';
import Button from '@atlaskit/button';
import AddCircleIcon from '@atlaskit/icon/glyph/add-circle';
import FieldText from '@atlaskit/field-text';
import Select from '@atlaskit/select';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import uuid from 'uuid/v4';
import { connect } from 'react-redux';

import { Table as API } from '../../../server';
import Styled from './styled';

class Preferences extends React.Component {
  constructor(props) {
    super(props);
    this.unmount = false;
    this.console = this.props.console;
    this.table = this.props.table;
    this.state = {
      loading: true,
    };

    this.onInsertClick = this.onInsertClick.bind(this);
  }

  componentWillMount() {
    this.console.log('© Preferences - Ready');
    API.table({
      dispatch: this.props.dispatch,
      success: (data) => {
        if (this.unmount) return;
        if (!this.table) {
          const index = 0;
          this.table = data[index];
        }
        this.props.change(this.table);
        this.setState({ loading: false });
      },
    });
  }

  componentDidUpdate() {
    this.console.log('© Preferences - Rendered');
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onInsertClick() {
    const rules = [];
    const length = window.parseInt(this.number.state.value);

    for (let i = 0; i < length; i += 1) {
      rules.push({ uuid: uuid() });
    }

    this.props.add(rules);
    this.number.setState({ value: 1 });
  }

  renderTableSelect() {
    const options = this.props.tables.map(val => ({
      label: val.Table,
      value: val.Table,
    }));

    const active = options.find(elem => elem.label === this.table) || options[0];
    const props = {
      isLoading: this.state.loading,
      options,
      placeholder: 'Select a table',
      spacing: 'compact',
      value: active,
      onChange: (option) => {
        this.table = option.label;
        this.props.change(this.table);
        this.setState({});
      },
    };

    return <Select {...props} />;
  }

  renderNumberInput() {
    const props = {
      compact: true,
      max: '10',
      min: '1',
      ref: (node) => { this.number = node; },
      shouldFitContainer: true,
      type: 'number',
      value: 1,
    };

    return <FieldText {...props} />;
  }

  renderInsertButton() {
    const props = {
      iconBefore: <AddCircleIcon size="small" label="Insert Row" />,
      onClick: this.onInsertClick,
    };

    return <Button {...props}>Insert Row</Button>;
  }

  renderOptionsDropDown() {
    const props = {
      position: 'bottom right',
      shouldAllowMultilineItems: true,
      trigger: 'Options',
      triggerType: 'button',
    };

    return (
      <DropdownMenu {...props}>
        <DropdownItemGroup title="Ranking">
          <DropdownItem onClick={() => this.props.sort('asc')}>A to Z Group</DropdownItem>
          <DropdownItem onClick={() => this.props.sort('dec')}>Z to A Group</DropdownItem>
        </DropdownItemGroup>
        <DropdownItemGroup title="Other">
          <DropdownItem onClick={() => this.props.remove('DELETE_ALL')}>Delete All Rows</DropdownItem>
        </DropdownItemGroup>
      </DropdownMenu>
    );
  }

  render() {
    return (
      <Styled.Preferences>
        <Styled.Flex>
          <Styled.FlexItem nowrap>
            <div style={{ width: 200 }}>
              {this.renderTableSelect()}
            </div>
          </Styled.FlexItem>
          <Styled.FlexItem />
          <Styled.FlexItem nowrap>
            <Styled.Textbox style={{ minWidth: 100 }}>
              {this.renderNumberInput()}
            </Styled.Textbox>
          </Styled.FlexItem>
          <Styled.FlexItem nowrap>
            {this.renderInsertButton()}
          </Styled.FlexItem>
          <Styled.FlexItem nowrap>
            {this.renderOptionsDropDown()}
          </Styled.FlexItem>
        </Styled.Flex>
      </Styled.Preferences>
    );
  }
}

Preferences.propTypes = {
  add: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  console: PropTypes.shape().isRequired,
  remove: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  table: PropTypes.string,
  tables: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

Preferences.defaultProps = {
  table: '',
};

const mapStateToProps = state => ({
  tables: state.Table,
});

export default connect(mapStateToProps)(Preferences);
